import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icon-arrow-right-active.svg'


const _hoisted_1 = { class: "buttons grid" }
const _hoisted_2 = { class: "col md:col-6" }
const _hoisted_3 = { class: "col md:col-6" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "title-bar" }
const _hoisted_6 = { class: "panel--container" }
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = { class: "toolbar-container" }
const _hoisted_9 = { class: "toolbar" }
const _hoisted_10 = { class: "mobile-filter" }
const _hoisted_11 = { class: "desktop-filter" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "dropdown-row" }
const _hoisted_15 = ["colspan"]
const _hoisted_16 = { class: "table-dropdown" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_UserCSVUpload = _resolveComponent("UserCSVUpload")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_ButtonBar = _resolveComponent("ButtonBar")!
  const _component_ListMenu = _resolveComponent("ListMenu")!
  const _component_Search = _resolveComponent("Search")!
  const _component_FilterMenu = _resolveComponent("FilterMenu")!
  const _component_MobileSideMenu = _resolveComponent("MobileSideMenu")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_TableCell = _resolveComponent("TableCell")!
  const _component_TableDropdown = _resolveComponent("TableDropdown")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_MobileBottomBar = _resolveComponent("MobileBottomBar")!
  const _component_authenticated_layout = _resolveComponent("authenticated-layout")!

  return (_openBlock(), _createBlock(_component_authenticated_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_Modal, {
          modelValue: false,
          title: _ctx.warning.title,
          onCloseWarning: _ctx.closeWarning
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.globalModal.body), 1)
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_Button, { text: "Cancel" }),
            _createVNode(_component_Button, { text: "Confirm" })
          ]),
          _: 1
        }, 8, ["title", "onCloseWarning"]),
        _createVNode(_component_Modal, {
          modelValue: _ctx.showCSVUploadModal,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showCSVUploadModal) = $event)),
          title: "documents.upload",
          subTitle: "common.add-files",
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCSVUploadModal = false)),
          onConfirm: _ctx.uploadCSV
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_UserCSVUpload, {
                modelValue: _ctx.fileModel,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileModel) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          footer: _withCtx(({ confirm, cancel }) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_Button, {
                  text: "common.cancel-action",
                  size: "sm",
                  variant: "secondary",
                  onClick: cancel,
                  block: ""
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Button, {
                  text: "Continue",
                  size: "sm",
                  disabled: false,
                  onClick: confirm,
                  block: ""
                }, null, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "onConfirm"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", null, [
              _createVNode(_component_TranslatedText, { path: "models.user.list.title" })
            ]),
            (_ctx.showCSVuploadButton)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  text: "Upload User CSV",
                  class: _normalizeClass('btn-margin'),
                  onClick: _ctx.navigateToCSVUpload
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.userHasPermission('user:create'))
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  text: "models.user.add",
                  onClick: _ctx.navigateToCreate
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_ButtonBar, {
                      onToggleSort: _ctx.toggleSort,
                      onToggleFilter: _ctx.toggleFilter,
                      onOpenSearch: _ctx.openSearch
                    }, null, 8, ["onToggleSort", "onToggleFilter", "onOpenSearch"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args))),
                      class: _normalizeClass({ open: _ctx.buttonBarData.filterOpen })
                    }, [
                      _createVNode(_component_TranslatedText, { path: "filter.title" })
                    ], 2)
                  ]),
                  _createVNode(_component_ListMenu, {
                    menuItems: _ctx.mobileSortItems,
                    show: _ctx.buttonBarData.sortOpen,
                    onClickMenuItem: _ctx.handleClickSort,
                    onToggleMenu: _ctx.toggleSort
                  }, null, 8, ["menuItems", "show", "onClickMenuItem", "onToggleMenu"]),
                  _createVNode(_component_Search, {
                    id: 'search-bar',
                    class: "style-standard h-pad",
                    searchText: _ctx.search,
                    searchOpen: _ctx.buttonBarData.searchOpen,
                    onCloseSearch: _ctx.closeSearch,
                    onFilterSearch: _ctx.filterSearch
                  }, null, 8, ["searchText", "searchOpen", "onCloseSearch", "onFilterSearch"])
                ])
              ])
            ]),
            (_ctx.buttonBarData.filterOpen)
              ? (_openBlock(), _createBlock(_component_FilterMenu, {
                  key: 0,
                  filters: _ctx.filters,
                  datePickers: _ctx.datePickers,
                  dateFilterButtons: _ctx.dateFilterButtons,
                  onSelectAll: _ctx.selectAll,
                  onToggleChip: _ctx.toggleChip,
                  onSelectFilter: _ctx.selectFilter,
                  onFilterDateByDatePicker: _ctx.filterDateByInput,
                  onFilterDateByButton: _ctx.filterDateByButton,
                  onClearAllFilters: _ctx.clearAllFilters
                }, null, 8, ["filters", "datePickers", "dateFilterButtons", "onSelectAll", "onToggleChip", "onSelectFilter", "onFilterDateByDatePicker", "onFilterDateByButton", "onClearAllFilters"]))
              : _createCommentVNode("", true),
            (_ctx.buttonBarData.filterOpen)
              ? (_openBlock(), _createBlock(_component_MobileSideMenu, {
                  key: 1,
                  sideMenu: _ctx.sideMenuItems,
                  menuTitle: _ctx.filterTitle,
                  inSubmenu: _ctx.inSubmenu,
                  datePickers: _ctx.datePickers,
                  dateFilterActive: _ctx.mobileDateFiltersActive,
                  dateFilterButtons: _ctx.dateFilterButtons,
                  onClickDateFilter: _ctx.clickDateFilter,
                  onSelectFilter: _ctx.selectFilter,
                  onCloseFilters: _ctx.toggleFilter,
                  onFilterDateByButton: _ctx.filterDateByButton,
                  onFilterDateByInput: _ctx.filterDateByInput,
                  onClickMenuItem: _ctx.clickFilterItem,
                  onGoBack: _ctx.goBack
                }, null, 8, ["sideMenu", "menuTitle", "inSubmenu", "datePickers", "dateFilterActive", "dateFilterButtons", "onClickDateFilter", "onSelectFilter", "onCloseFilters", "onFilterDateByButton", "onFilterDateByInput", "onClickMenuItem", "onGoBack"]))
              : _createCommentVNode("", true),
            _createVNode(_component_TableList, {
              tableName: "users",
              totalRows: _ctx.totalUsers,
              customClass: _ctx.tableCustomClass,
              selectedRows: _ctx.selectedUserCheckboxes,
              deselectedRows: _ctx.deselectedUserCheckboxes,
              selectAllActive: _ctx.selectAllUsers,
              currentPage: _ctx.currentPage,
              actionsChip: _ctx.userActionsChip,
              paginated: "",
              showTableSelection: "",
              onChangeActivationStatus: _ctx.changeActivationStatus,
              onChangePage: _ctx.changePage,
              onChangeRowCount: _ctx.changeRowCount,
              onToggleAll: _ctx.toggleAll,
              onClearSelection: _ctx.clearTableSelection,
              onToggleActionsChip: _ctx.toggleActionsChip,
              onClickActionItem: _ctx.clickAction
            }, {
              head: _withCtx(() => [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", {
                    class: _normalizeClass({ hidden: _ctx.selectedUserCheckboxes.length })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desktopHeadings, (heading, index) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: heading.id,
                        class: _normalizeClass(["sort", [
                      heading.mobileFeatured ? 'primary' : 'secondary',
                      {
                        active: index === _ctx.headingsData.sortActiveIndex,
                        sortable: heading.sortable,
                        asc: heading.sortable && heading.sortOrder === 'asc',
                        desc: heading.sortable && heading.sortOrder === 'desc',
                        checkbox: heading.dataType === 'checkbox',
                        narrow: !heading.title,
                        center: heading.center,
                      },
                    ]]),
                        onClick: ($event: any) => (
                      heading.sortable
                        ? _ctx.handleClickSort({
                            title: heading.title,
                            id: heading.id,
                          })
                        : null
                    )
                      }, [
                        (heading.dataType === 'checkbox')
                          ? (_openBlock(), _createBlock(_component_Checkbox, {
                              key: 0,
                              active: _ctx.selectAllUsers,
                              selectAll: true,
                              onToggleAll: _ctx.toggleAll
                            }, null, 8, ["active", "onToggleAll"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_TranslatedText, {
                          path: heading.title
                        }, null, 8, ["path"])
                      ], 10, _hoisted_12))
                    }), 128))
                  ], 2)
                ])
              ]),
              body: _withCtx(() => [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData, (row, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: row.id
                    }, [
                      _createElementVNode("tr", {
                        class: _normalizeClass(["row", {
                      alternate: _ctx.isOdd(i),
                      deactivated: row.deactivated,
                      active: _ctx.headingsData.rowActiveUser === row.rowId,
                      selected:
                        _ctx.selectedUserCheckboxes.includes(row.id) &&
                        !_ctx.deselectedUserCheckboxes.includes(row.id),
                    }])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cols, (col) => {
                          return (_openBlock(), _createBlock(_component_TableCell, {
                            class: _normalizeClass([
                        _ctx.desktopHeadings[col.id]?.mobileFeatured
                          ? 'primary'
                          : 'secondary',
                        { narrow: !_ctx.desktopHeadings[col.id]?.title },
                      ]),
                            rowActive: 
                        _ctx.selectedUserCheckboxes.includes(row.id) &&
                        !_ctx.deselectedUserCheckboxes.includes(row.id)
                          ? true
                          : false
                      ,
                            dataType: col.dataType,
                            data: col.data,
                            dataInfo: col.dataInfo,
                            key: col.id,
                            onClickCell: ($event: any) => (_ctx.handleClickCell(row.id, row.rowId)),
                            onClickRow: ($event: any) => (_ctx.handleClickRow(row.rowId)),
                            onToggleCheckbox: ($event: any) => (_ctx.toggleCheckbox(row.id))
                          }, null, 8, ["class", "rowActive", "dataType", "data", "dataInfo", "onClickCell", "onClickRow", "onToggleCheckbox"]))
                        }), 128)),
                        _createElementVNode("td", {
                          class: "td-button",
                          onClick: ($event: any) => (_ctx.handleClickCell(row.id, row.rowId))
                        }, [...(_cache[4] || (_cache[4] = [
                          _createElementVNode("button", null, [
                            _createElementVNode("img", {
                              src: _imports_0,
                              alt: "",
                              style: {"height":"14px","width":"7px"}
                            })
                          ], -1)
                        ]))], 8, _hoisted_13)
                      ], 2),
                      (_ctx.headingsData.rowActiveUser === row?.rowId)
                        ? (_openBlock(), _createBlock(_component_TableDropdown, { key: 0 }, {
                            wrapper: _withCtx(() => [
                              _createElementVNode("tr", _hoisted_14, [
                                _createElementVNode("td", {
                                  colspan: row.cols.length
                                }, [
                                  _createElementVNode("table", _hoisted_16, [
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cols, (col) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: col.id
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desktopHeadings, (heading) => {
                                            return (_openBlock(), _createElementBlock("th", {
                                              key: heading.id,
                                              class: _normalizeClass(["dropdown-heading", [
                                    {
                                      show:
                                        !heading.mobileFeatured &&
                                        col.colId === heading.id &&
                                        !heading.notShownInMobile,
                                    },
                                  ]])
                                            }, [
                                              _createElementVNode("span", null, _toDisplayString(heading.title), 1)
                                            ], 2))
                                          }), 128)),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desktopHeadings, (heading) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                              key: heading.id,
                                              class: _normalizeClass(["dropdown-value", [
                                    {
                                      show:
                                        !heading.mobileFeatured &&
                                        col.colId === heading.id &&
                                        !heading.notShownInMobile,
                                    },
                                  ]])
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.data, (item, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
                                                  item
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                                        _createTextVNode(_toDisplayString(item), 1),
                                                        (
                                          col.data.length > 1 &&
                                          index < col.data.length - 1
                                        )
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, ", "))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_19, "-"))
                                                ], 64))
                                              }), 128))
                                            ], 2))
                                          }), 128))
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.navigateToUser(row.id))
                                  }, " View User ", 8, _hoisted_20)
                                ], 8, _hoisted_15)
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["totalRows", "customClass", "selectedRows", "deselectedRows", "selectAllActive", "currentPage", "actionsChip", "onChangeActivationStatus", "onChangePage", "onChangeRowCount", "onToggleAll", "onClearSelection", "onToggleActionsChip", "onClickActionItem"])
          ])
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "padding-container" }, null, -1)),
        _createVNode(_component_MobileBottomBar, { onClick: _ctx.navigateToCreate }, null, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}